// extracted by mini-css-extract-plugin
module.exports = {"ShimmerBackground":"ShimmeringBackground_ShimmerBackground__1heHC"};